<template>
  <booking>
    <div class="booking-up-coming-event">
      <div class="lists" v-if="reservations.length">
        <booking-box-up-coming-event
          v-for="(item, index) in reservations"
          :key="index"
          :data="item"
          v-on:model="getRequestReservation"
        ></booking-box-up-coming-event>
      </div>
      <div class="no-data" v-else>
        <span>There is no event</span>
      </div>
    </div>
  </booking>
</template>

<script>
import Booking from '@/components/user/Booking'
import BookingBoxUpComingEvent from '@/components/common/BookingBoxUpComingEvent'
import { getRequestReservations } from '@/api/reservation'

export default {
  name: 'booking-up-coming-event',
  components: { BookingBoxUpComingEvent, Booking },
  data() {
    return {
      reservations: []
    }
  },
  created() {
    this.getRequestReservation()
  },
  methods: {
    getRequestReservation() {
      console.log('uid:', this.$store.getters.userInfo.uid)
      getRequestReservations(this.$store.getters.userInfo.uid).then(res => {
        this.reservations = res
        this.$forceUpdate()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.booking-up-coming-event {
  .lists {
    margin: 30px 0 0 0;
    .booking-box-up-coming-event {
      margin-bottom: 20px;
    }
  }

  .no-data {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    width: inherit;
    background-color: #f5f5f5;
    margin: 30px 0 0 0;
  }
}
</style>
